export default {
  groupName: 'adpi-category-covid',
  appName: 'Cross Category',
  baseRoute: '/dashboard/adpi-category-covid',
  label: 'Ad Effect Cross Category Dashboard',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'Ad Effect Cross Category Advertising Dashboard'
};



// WEBPACK FOOTER //
// ./src/app/configuration/CategoryCovid/config/main.js